<!--
* @Name：授标结果
* @Author: 王超
* @Date: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card v-for="(item, index) in suppInfoList" :key="item.subjectNo" :row-index="index + 1">
      <van-row>
        <span>招标分项号：</span>
        <span>{{ item.subjectNo }}</span>
      </van-row>
      <van-row>
        <span>物料编码：</span>
        <span>{{ item.materialId }}</span>
      </van-row>
      <van-row>
        <span>物料信息补充：</span>
        <span>{{ item.materialExt }}</span>
      </van-row>
      <van-row>
        <span>基本单位：</span>
        <span>{{ item.unit }}</span>
      </van-row>
      <van-row>
        <span>基本单位说明：</span>
        <span>{{ item.unitInfo }}</span>
      </van-row>
      <van-row>
        <span>采购数量：</span>
        <span>{{ item.quantity }}</span>
      </van-row>
      <van-row>
        <span>目标税率：</span>
        <span>{{ item.targetTax }}</span>
      </van-row>
      <van-row>
        <span>预估价格：</span>
        <span>{{ item.predictPrice }}</span>
      </van-row>
      <van-row>
        <span>交货地点：</span>
        <span>{{ item.destination }}</span>
      </van-row>
      <van-row>
        <van-button type="info" size="normal" style="margin-bottom: 5px" @click="clickItem(item)"
          >查看授标结果</van-button
        >
      </van-row>
    </hi-card>
    <bid-detail-info
      v-if="detailsVisible"
      :details-visible="detailsVisible"
      :bid-supp-list="detailsItem"
      @close-details-dialog="detailsVisible = false"
    />
  </div>
</template>

<script>
export default {
  name: 'suppInfoList',
  components: {
    'bid-detail-info': () => import('./BidDetailInfo')
  },
  data() {
    return {
      detailsVisible: false,
      detailsItem: []
    }
  },
  props: {
    suppInfoList: {
      type: Array,
      required: true
    }
  },
  methods: {
    clickItem(item) {
      this.detailsItem = item.rankInfoList
      this.detailsVisible = true
    }
  }
}
</script>
